import { render, staticRenderFns } from "./ClientPdfScanner.vue?vue&type=template&id=4ffd95f6&scoped=true&"
import script from "./ClientPdfScanner.vue?vue&type=script&lang=js&"
export * from "./ClientPdfScanner.vue?vue&type=script&lang=js&"
import style0 from "./ClientPdfScanner.vue?vue&type=style&index=0&id=4ffd95f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffd95f6",
  null
  
)

export default component.exports